import { setAlert } from "./alert";
import {SET_ERROR} from "./types";
import { redirect } from "./user";

export const setError = (inputId,msg) => (dispatch) => {
  dispatch({
    type: SET_ERROR,
    payload: { inputId,msg},
  });

};

//Common error handler for all redux action -- Added By Nipul
export const handleError = (err, dispatch) => {
    const success = err.response.data.success;
    if (!success) {
        if (err.response.status === 401)
            dispatch(redirect('/error403'))
        else
            dispatch(setAlert(err.response.data.message, "danger"));
    }
}
